import React, { useState, useEffect } from "react";
import { useNavigate,useParams } from "react-router-dom";
import axios from "axios";
import Swal from 'sweetalert2';
//import Select from 'react-dropdown-select';
import AsyncSelect from 'react-select/async';

import Loading from 'react-simple-loading';
import Modal from 'react-modal';



const Location = ({ getContractDetails }) => {
    const navigate = useNavigate();
    const params = useParams();
    const contract_id = params.contract_id;
    const [citiesOptions, setCitiesOptions] = useState(null);
    const [zipsOptions, setZipsOptions] = useState(null);
    const [isBtn, setIsBtn] = useState(false);
    const [location, setLocation] = useState(null);
    const [contract, setContract] = useState(null);

    const [addLocationModalOpen, setAddLocationModalOpen] = useState(false);

    useEffect(() => {

        window.scrollTo(0, 0)

        if (!localStorage.getItem('@roampays-user')) {
            navigate("/login")
        }
        getCitiesOptions();
        getZipsOptions();
        getContract();


    }, []);






    const getContract = async () => {
        axios.get(process.env.REACT_APP_API_URL + "/get-contract-by-id/"+contract_id, {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        })
            .then(function (response) {

                setContract(response.data.contract);
                setLocation({ label: response.data.contract?.city + ", " + response.data.contract?.state_name, value: response.data.contract?.location_id })

                setIsBtn(false)

            })
            .catch(function (error) {
                setIsBtn(false)
                if (error.status == 403) navigate("/login")
                else
                    Swal.fire({ icon: "error", title: "Contract Not Found", text: error.message });

            });
    }

    const getCitiesOptions = async (e) => {


        axios.get(process.env.REACT_APP_API_URL + "/get-cities-options", {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        })
            .then(function (response) {
                if (response?.data?.status) {
                    setCitiesOptions(response?.data?.options);
                }

            })
            .catch(function (error) {
                if (error.status == 403) navigate("/login")
                else
                    Swal.fire({ icon: "error", title: "Cities options error", text: error.message });

            });
    }

    const getZipsOptions = async (e) => {


        axios.get(process.env.REACT_APP_API_URL + "/get-zips-options", {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        })
            .then(function (response) {
                if (response?.data?.status) {
                    setZipsOptions(response?.data?.options);
                }

            })
            .catch(function (error) {
                if (error.status == 403) navigate("/login")
                else
                    Swal.fire({ icon: "error", title: "Zip options error", text: error.message });

            });
    }

    const saveLocation = async (e) => {
        e.preventDefault();
        setIsBtn(true);

        if (!location) {
            Swal.fire({ icon: "error", title: "Error", text: "Select location" });
            setIsBtn(false)
        } else {


            await axios.post(process.env.REACT_APP_API_URL + "/save-contract-location-by-id", {
                location_id: location.value,
                contract_id:contract_id
            }, {
                headers: {
                    'Content-Type': 'application/json'
                },
                withCredentials: true
            })
                .then(function (response) {

                    if (response?.data?.status) {
                        setAddLocationModalOpen(false);
                        getContractDetails();
                        getContract();
                        const l = location?.label?.split(", ");

                        getPerDiem(l[0],l[1],contract_id);

                    }
                    else {
                        Swal.fire({ icon: "error", title: "Error", text: response?.data?.message });
                    }

                    setIsBtn(false)
                })
                .catch(function (error) {
                    setIsBtn(false)

                    Swal.fire({ icon: "error", title: "Error", text: error.message });

                });

        }
    };


   const getPerDiem = async (city, state, contract_id) => {
    const year = new Date().getFullYear();
    const month = new Date().getMonth(); // 0-based
    const normalizedCity = city ? city.trim().toLowerCase() : "";

    const p1 = new Promise((resolve, reject) => {
        axios
            .get(
                `https://api.gsa.gov/travel/perdiem/v2/rates/city/${encodeURIComponent(city)}/state/${state}/year/${year}?API_KEY=${process.env.REACT_APP_GSA_API_KEY}`,
                { headers: {} }
            )
            .then((r) => {
                const rates = r?.data?.rates;
                if (!rates?.length) return resolve([0, 0]);

                const rateEntries = rates[0]?.rate;
                if (!rateEntries?.length) return resolve([0, 0]);

                // Case-insensitive city match
                const matchedRate = rateEntries.find(rt =>
                    rt?.city?.toLowerCase().includes(normalizedCity)
                );

                // Fallback: first entry if no match
                const selectedRate = matchedRate || rateEntries[0];

                const housing =
                    selectedRate?.months?.month?.[month]?.value ?? 0;

                const meals = selectedRate?.meals ?? 0;

                resolve([meals, housing]);
            })
            .catch((err) => {
                reject(err);
            });
    });

    const p2 = new Promise((resolve, reject) => {
        axios
            .get(
                `https://api.gsa.gov/travel/perdiem/v2/rates/conus/mie/${year}?API_KEY=${process.env.REACT_APP_GSA_API_KEY}`,
                { headers: {} }
            )
            .then((r) => {
                const rate = r?.data?.[0];
                const others = rate?.incidental ?? 0;
                resolve([others]);
            })
            .catch((err) => {
                reject(err);
            });
    });

    const pa = await Promise.all([p1, p2])
        .then((values) => {
            const meals = values[0][0];
            const housing = values[0][1];
            const others = values[1][0];

            axios.post(
                process.env.REACT_APP_API_URL + "/save-max-allowances-by-id/",
                {
                    contract_id: contract_id,
                    housing_max: housing,
                    meals_max: meals,
                    others_max: others,
                },
                {
                    headers: { "Content-Type": "application/json" },
                    withCredentials: true,
                }
            );

            return [housing, meals];
        })
        .catch((error) => {
            console.log(error);
            return [0, 0];
        });

    return pa;
};


    function isNumber(n) { return !isNaN(parseFloat(n)) && !isNaN(n - 0) }


    const filterOptions = (inputValue) => {
       

        if (isNumber(inputValue) && zipsOptions?.length > 0) {
            return zipsOptions?.filter(function (i) {
                if (this.count < 10 && i.label.toUpperCase().includes(inputValue)) {
                    this.count++;
                    return true;
                }
                return false;
            }, { count: 0 })
        }
        else if (citiesOptions?.length > 0) {
            return citiesOptions?.filter(function (i) {
                if (this.count < 10 && i.label.toUpperCase().includes(inputValue.toUpperCase())) {
                    this.count++;
                    return true;
                }
                return false;
            }, { count: 0 })
        }


      };

    const loadLocationOptions = (inputValue,callback) => {

       
        setTimeout(() => {
            callback(filterOptions(inputValue));
          }, 500);
         

       
      };
    
  


    return (
        <>

            <div className="input-box" onClick={() => setAddLocationModalOpen(true)} >

                <label className="color-light fs-14 flex-grow-1"  >{contract?.location_id > 0 ? contract?.city + ", " + contract?.state_name : ""} </label>
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M10.674 9.0008L6.83691 5.16372L8.16274 3.83789L13.3257 9.0008L8.16274 14.1637L6.83691 12.8379L10.674 9.0008Z" fill="white" />
                </svg>
            </div>


            <Modal
                isOpen={addLocationModalOpen}
                onRequestClose={() => { setAddLocationModalOpen(false) }}
                contentLabel="Add Location"
                className="modal"
                overlayClassName="overlay"
            >
                <div className="modal-title" >
                    <div className="flex-equal justify-content-start " ></div>
                    <h3 className="flex-equal justify-content-center fs-18 fs-helvetica  color-white">Add Location</h3>
                    <div className="flex-equal justify-content-end" >
                        <div className="icon" onClick={() => setAddLocationModalOpen(false)}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                <path d="M8.0312 7L10.8154 9.78423L9.78423 10.8154L7 8.0312L4.21577 10.8154L3.18457 9.78423L5.9688 7L3.18457 4.21577L4.21577 3.18457L7 5.9688L9.78424 3.18457L10.8154 4.21577L8.0312 7Z" fill="white" />
                            </svg>
                        </div>
                    </div>
                </div>
                <form onSubmit={saveLocation} action="#"  >
                    <div className="modal-body min-height" >
                        <div className="box modal align-self-stretch"  >
                            <div className="fd-column g-18" >
                                <div className="input-container color-light fs-12" >
                                    <div className="auto-dropdown auto-input-box" >
                                    <AsyncSelect id="location" name="location"
                                            className="react-select" classNamePrefix="react-select"
                                            defaultValue={{ "value": location?.value, "label": location?.label }}
                                            loadOptions={loadLocationOptions}
                                            value={{ "value": location?.value, "label": location?.label }}
                                            onChange={(y) => { setLocation(y) }}
                                            noOptionsMessage={({ inputValue }) => !inputValue ? "Start Typing" : "No results found"}
                                        />
                                     
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="modal-footer  justify-content-space-between" >
                        <button className="btn btn-secondary" type="button" onClick={() => { setAddLocationModalOpen(false) }}>Cancel</button>
                        <button className=" btn btn-primary" type="submit" disabled={isBtn}>
                            {isBtn ? <Loading size={'20px'} /> : 'Save'}</button>
                    </div>
                </form>
            </Modal>
        </>
    );
};

export default Location;